// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

export const ASSIGN = "cnspec.policy.PolicyResolver.Assign";
